<template>
  <div>
    <DynamicFormList :active.sync="active" :items="itemsLocalMapped">
      <template #items="{ item }">
        <DynamicFormListItem #default="{ active, toggle }">
          <ScheduleOREMeetingForm
            :item="item"
            :readonly="!active"
            :scheduled-dates="scheduledDates"
            editting
            @submit="edit"
            @cancel="toggle"
          >
            <template
              v-if="consultationProcess && !active && !submitted"
              #actions
            >
              <div class="col-12 col-lg-2 pt-4 order-last order-lg-0">
                <div class="row">
                  <div class="col-12 pt-0 pt-lg-2">
                    <div class="h-100 text-right">
                      <MenuDropDown
                        :responsive="true"
                        title="Acciones"
                        :items="[
                          {
                            name: 'Editar',
                            icon: 'fas fa-edit fa-fw text-green',
                            border: 'bottom',
                            click: toggle,
                          },
                          {
                            name: 'Eliminar',
                            icon: 'fas fa-times-circle fa-fw text-red',
                            click: () => remove(item),
                          },
                        ]"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </ScheduleOREMeetingForm>
        </DynamicFormListItem>
      </template>

      <template #form="{ toggle }">
        <ScheduleOREMeetingForm
          :scheduled-dates="scheduledDates"
          @submit="add"
          @cancel="toggle"
        />
      </template>

      <template v-if="!submitted" #form-toggler="{ toggle }">
        <div class="text-right pr-3">
          <ActionButton
            :responsive="false"
            text="Añadir"
            variant="success"
            i="fas fa-file-plus"
            @click="toggle"
          />
        </div>
      </template>
    </DynamicFormList>
  </div>
</template>

<script>
import { DynamicFormList, DynamicFormListItem } from '@/components/common';
import MenuDropDown from 'dropdown';
import ActionButton from 'ActionButton';
import ScheduleOREMeetingForm from './_components/ScheduleOREMeetingForm';
import { scheduleOREMeetingApi } from './_api';
import { payloadToModel, sortByDate } from './_utils';
import { scheduleOREMeetingTypesEnum } from './_types';
import { tapRequestStatusesEnum } from '@/components/pei/ubication-tech-assistance/_types';

export default {
  name: 'ScheduleOREMeeting',
  components: {
    DynamicFormList,
    DynamicFormListItem,
    MenuDropDown,
    ActionButton,
    ScheduleOREMeetingForm,
  },
  props: {
    submitted: { type: Boolean, default: false },
    tapRequestId: { type: [Number, String], required: true, default: null },
    tapRequestStatus: { type: Object, required: true, default: null },
    meetingType: {
      type: String,
      required: true,
      default: null,
      validator: (value) => {
        const values = Object.keys(scheduleOREMeetingTypesEnum);
        const valid = values.includes(value);
        if (!valid) {
          // eslint-disable-next-line no-console
          console.error(
            `Invalid prop: Invalid prop: value check failed for prop "meetingType".\nExpected String with one of the following values: ${values.join(
              ', '
            )}.\nGot String with value ${value}.`
          );
        }
        return valid;
      },
    },
    items: { type: Array, required: true, default: () => [] },
  },
  data: () => ({ active: false, itemsLocal: [] }),
  computed: {
    items_sync: {
      get() {
        return this.items;
      },
      set(value) {
        this.$emit('update:items', value);
        this.$emit('input', value.length);
      },
    },
    itemsLocalMapped() {
      return this.itemsLocal.map(payloadToModel);
    },
    scheduledDates() {
      return this.items_sync.map(({ id, date }) => ({ id, date }));
    },
    consultationProcess() {
      if (!this.tapRequestStatus) {
        return false;
      }
      return (
        this.tapRequestStatus?.id ===
        tapRequestStatusesEnum['Proceso de Consulta']
      );
    },
  },
  methods: {
    async add(item, reset) {
      if (this.submitted) {
        return;
      }
      const result = await scheduleOREMeetingApi.create({
        requestId: this.tapRequestId,
        meetingTypeId: scheduleOREMeetingTypesEnum[this.meetingType],
        model: item,
      });
      if (result) {
        this.items_sync.push(result);
        this.itemsLocal.push(result);
        reset(true);
      }
    },
    async edit(item, reset) {
      if (this.submitted) {
        return;
      }
      const result = await scheduleOREMeetingApi.edit({
        requestId: this.tapRequestId,
        meetingTypeId: scheduleOREMeetingTypesEnum[this.meetingType],
        id: item.id,
        model: item,
      });
      if (result) {
        const index = this.items_sync.findIndex((x) => x.id === result.id);
        this.items_sync.splice(index, 1, result);
        this.itemsLocal.splice(index, 1, result);
        reset();
      }
    },
    async remove(item) {
      if (this.submitted) {
        return;
      }
      const result = await scheduleOREMeetingApi.remove(item.id);
      if (result) {
        const index = this.items_sync.findIndex((x) => x.id === item.id);
        this.items_sync.splice(index, 1);
        this.itemsLocal.splice(index, 1);
      }
    },
  },
  watch: {
    items_sync: {
      handler(value) {
        this.$emit('input', value);
        if (!this.active && !value.length) {
          this.active = true;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.itemsLocal = [
      ...this.items.sort((a, b) => sortByDate(a.date, b.date)),
    ];
  },
};
</script>
